module.exports = __webpack_public_path__ + "static/media/d22ru.bf1e90a6.pdf";